import axios from 'axios'

// wtf duble api
axios.defaults.baseURL = '/api/v1/'

export const fetchProfileList = async () => {
  const response = await axios.get('profileList')
  return response.data
}

export const fetchProfileTypeList = async () => {
  const response = await axios.get('profileTypeList')
  return response.data
}

export const fetchProfilePropsValueList = async (id) => {
  const response = await axios.get(`profilePropsValueList?id=${id}`)
  return response.data
}

export const fetchProfilePropsValueDefaultList = async (id) => {
  const response = await axios.get(`profilePropsValueDefaultList?id=${id}`)
  return response.data
}

export const fetchCheckInn = async (inn) => {
  const response = await axios.get(`checkInn?inn=${inn}`)
  return response.data
}

export const profileSave = async (data) => {
  const response = await axios.post(`profileSave`, data)
  return response.data
}

export const profileRemove = async (id) => {
  const response = await axios.get(`profileRemove?id=${id}`)
  return response.data
}

export default {
  profileList: fetchProfileList,
  profileTypeList: fetchProfileTypeList,
  profilePropsValueList: fetchProfilePropsValueList,
  profilePropsValueDefaultList: fetchProfilePropsValueDefaultList,
  checkInn: fetchCheckInn,
  profileSave: profileSave,
  profileRemove: profileRemove
}

// export let fetchProfiles = async () => {
//   let res = await axios.get('profiles')
//
//   return res.data
// }
//
// export let saveProfile = async (profile) => {
//   let res = await axios.post('profiles', profile)
//
//   return res.data
// }
//
// export let removeProfile = async (id) => {
//   let res = await axios.delete('profiles/' + id)
//   return res.data
// }



// WEBPACK FOOTER //
// ./src/api/profiles.js